import { Button, Typography } from "@mui/material";

export default function ActionButton({ variant = "contained", onClick, disabled, children, sx }) {
  return (
    <Button
      variant={variant}
      className="group w-full rounded-full p-2 normal-case"
      sx={sx}
      onClick={onClick}
      disabled={disabled}
    >
      <Typography className="text-sm font-normal group-hover:font-semibold">{children}</Typography>
    </Button>
  );
}
